import Vue from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import {
  faPause,
  faPlay,
  faClock,
  faAward,
  faStar,
  faTrophyAlt,
  faMedal,
  faCompactDisc,
  faExclamationCircle,
  faInfoCircle,
} from '@fortawesome/pro-solid-svg-icons';
import {
  faUsers,
} from '@fortawesome/pro-regular-svg-icons';
import {
  faSpotify,
} from '@fortawesome/free-brands-svg-icons';


library.add(
  faUsers,
  faPause,
  faPlay,
  faSpotify,
  faClock,
  faAward,
  faStar,
  faTrophyAlt,
  faMedal,
  faCompactDisc,
  faExclamationCircle,
  faInfoCircle,
);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.config.productionTip = false;

new Vue({
  render: (h) => h(App),
}).$mount('#app');
